import { callFunctionIfExists } from "../../utils/GeneralUtils";
import { ReactNode, useRef } from "react";
import { Button } from "reactstrap";
import { Popover, Whisper } from "rsuite";
import { TypeAttributes } from "rsuite/esm/internals/types";

const MenuPopover = (options: ReactNode, onClose: () => void) => (
  <Popover
    className="sidebar-popover"
    full
    onClick={(e: any) => {
      e.stopPropagation();
      callFunctionIfExists(onClose);
    }}
  >
    {options}
  </Popover>
);

interface Props {
  id?: string;
  options: ReactNode;
  optionsProps?: any;
  dotsSize?: number;
  dotsPadding?: string;
  dotsTop?: number;
  placement?: TypeAttributes.Placement;
  iconColor?: string | null;
  onOpen?: () => void;
  onClose?: () => void;
  outline?: boolean;
}

const DotsOptionsMenu = ({
  id,
  options,
  optionsProps,
  dotsSize = 16,
  dotsPadding = "0 3px",
  dotsTop = 2,
  placement = "autoVerticalStart",
  iconColor = null,
  onOpen,
  onClose,
  outline = true,
}: Props) => {
  const whisperRef = useRef(null);
  //@ts-ignore
  const closeWhisper = () => whisperRef?.current.close();
  return (
    <Whisper
      preventOverflow
      placement={placement}
      controlId={id}
      trigger="click"
      ref={whisperRef}
      onEnter={onOpen}
      onExit={onClose}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      speaker={
        typeof options !== "function"
          ? MenuPopover(options, closeWhisper)
          : //@ts-ignore
            MenuPopover(options(...optionsProps), closeWhisper)
      }
    >
      <div className="d-inline-block pl-1">
        <Button
          className={`btn-icon-only rs-nav-item-menu-toggle`}
          style={{
            padding: dotsPadding,
            width: "unset",
            height: "unset",
          }}
          size="sm"
          outline={outline}
          color="secondary"
        >
          <i
            style={{
              fontSize: dotsSize,
              top: dotsTop,
              color: iconColor || "unset",
            }}
            id="dots-option-menu"
            className="mdi mdi-dots-horizontal"
          />
        </Button>
      </div>
    </Whisper>
  );
};

export default DotsOptionsMenu;
